export class RequestTreeModel {
    requestTreeId = 0;
    requestId = 0
    plantingLocationId = 0;
    plantingLocationText = null;
    campaignTreeId = 0;
    requestQnty = 0;
    approveQnty = 0;
    costPerQnty = 0;
    isWaitlist = false;

    treeName: string = null;
    
    isNew = true;
}

export class RequestCTreeModel {
    treeCommonName: string = null;
    treeSpeciesName: string = null;
    planting1LocationName = '';
    planting2LocationName = '';
    planting3LocationName = '';
    planting4LocationName = '';
    isWaitlist: number;
    qty1 = 0;
    qty2 = 0;
    qty3 = 0;
    qty4 = 0;
}

